<template lang="pug">
.loader
    svg#Loader(version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewbox='-50 -50 225 225' style='enable-background:new 0 0 152.27 152.9;' xml:space='preserve')
        g
            path(d='M150.11,84.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c0.97,0,1.78-0.65,2.06-1.53\
            c0.04-0.24,0.06-0.49,0.09-0.73c-0.01-0.11-0.01-0.22-0.03-0.33C152.02,85.49,151.15,84.75,150.11,84.75z')
            path(d='M152.27,72.51c0-0.15-0.02-0.29-0.04-0.44c-0.2-0.98-1.07-1.72-2.12-1.72c-1.19,0-2.16,0.97-2.16,2.16\
            c0,1.19,0.97,2.16,2.16,2.16c1.04,0,1.91-0.74,2.12-1.73C152.25,72.8,152.27,72.66,152.27,72.51z')
            path(d='M149.53,99.24c-0.91,0.25-1.58,1.08-1.58,2.07c0,0.49,0.17,0.94,0.44,1.3C148.79,101.49,149.18,100.37,149.53,99.24z')
            path(d='M147.95,58.11c0,1.19,0.97,2.16,2.16,2.16c0.38,0,0.74-0.11,1.05-0.28c-0.3-1.36-0.64-2.7-1.01-4.03c-0.02,0-0.03,0-0.04,0\
            C148.91,55.95,147.95,56.91,147.95,58.11z')
        g
            path(d='M135.71,117.87c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C133.55,116.9,134.51,117.87,135.71,117.87z')
            path(d='M135.71,103.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C133.55,102.5,134.51,103.47,135.71,103.47z')
            path(d='M135.71,89.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C133.55,88.1,134.51,89.07,135.71,89.07z')
            path(d='M135.71,74.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C133.55,73.7,134.51,74.67,135.71,74.67z')
            path(d='M135.71,55.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C137.87,56.91,136.9,55.95,135.71,55.95z')
            path(d='M135.71,41.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C137.87,42.51,136.9,41.55,135.71,41.55z')
            path(d='M133.55,29.31c0,1.19,0.97,2.16,2.16,2.16c0.78,0,1.45-0.41,1.83-1.03c-0.82-1.08-1.66-2.13-2.53-3.17\
            C134.16,27.56,133.55,28.36,133.55,29.31z')
        g
            path(d='M140.75,108.51c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C141.71,106.35,140.75,107.32,140.75,108.51z')
            path(d='M142.91,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C145.07,92.92,144.1,91.95,142.91,91.95z')
            path(d='M142.91,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C145.07,78.52,144.1,77.55,142.91,77.55z')
            path(d='M145.07,65.31c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C144.1,67.47,145.07,66.5,145.07,65.31z')
            path(d='M142.91,48.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C145.07,49.71,144.1,48.75,142.91,48.75z')
            path(d='M142.91,38.67c0.01,0,0.02,0,0.04,0c-0.62-1.08-1.26-2.14-1.92-3.19c-0.17,0.31-0.27,0.66-0.27,1.03\
            C140.75,37.7,141.71,38.67,142.91,38.67z')
        g
            path(d='M130.67,122.91c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C129.7,125.07,130.67,124.1,130.67,122.91z')
            path(d='M128.51,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C130.67,107.32,129.7,106.35,128.51,106.35z')
            path(d='M128.51,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C130.67,92.92,129.7,91.95,128.51,91.95z')
            path(d='M128.51,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C130.67,78.52,129.7,77.55,128.51,77.55z')
            path(d='M128.51,63.15c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C130.67,64.12,129.7,63.15,128.51,63.15z')
            path(d='M128.51,48.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C130.67,49.71,129.7,48.75,128.51,48.75z')
            path(d='M130.67,36.51c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C129.7,38.67,130.67,37.7,130.67,36.51z')
            path(d='M126.35,22.11c0,1.19,0.97,2.16,2.16,2.16c1.06,0,1.95-0.77,2.12-1.79c-0.84-0.85-1.71-1.67-2.59-2.48\
            C127.07,20.22,126.35,21.08,126.35,22.11z')
        g
            path(d='M123.47,130.11c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37C122.5,132.27,123.47,131.3,123.47,130.11z')
            path(d='M123.47,115.71c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37C122.5,117.87,123.47,116.9,123.47,115.71z')
            path(d='M121.31,99.15c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C123.47,100.12,122.5,99.15,121.31,99.15z')
            path(d='M121.31,84.75c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C123.47,85.71,122.5,84.75,121.31,84.75z')
            path(d='M121.31,70.35c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C123.47,71.31,122.5,70.35,121.31,70.35z')
            path(d='M119.74,13.42c-0.37,0.39-0.6,0.91-0.6,1.48c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37\
            c0.81,0,1.51-0.46,1.88-1.12C122.06,15.08,120.92,14.23,119.74,13.42z')
            path(d='M120.1,59.9c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C119.15,58.85,119.52,59.51,120.1,59.9z')
            path(d='M119.15,43.71c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16\
            c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37C119.52,42.3,119.15,42.96,119.15,43.71z')
            path(d='M120.1,31.1c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C119.15,30.05,119.52,30.71,120.1,31.1z')
        g
            path(d='M106.91,142.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c0.02,0,0.04,0,0.05-0.01\
            c0.51-0.22,1.02-0.46,1.53-0.69c0.36-0.39,0.58-0.9,0.58-1.47C109.07,143.32,108.1,142.35,106.91,142.35z')
            path(d='M106.91,132.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C104.75,131.3,105.71,132.27,106.91,132.27z')
            path(d='M106.91,113.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C109.07,114.52,108.1,113.55,106.91,113.55z')
            path(d='M106.91,99.15c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C109.07,100.12,108.1,99.15,106.91,99.15z')
            path(d='M106.91,84.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C109.07,85.71,108.1,84.75,106.91,84.75z')
            path(d='M106.91,70.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C109.07,71.31,108.1,70.35,106.91,70.35z')
            path(d='M106.91,60.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C104.75,59.3,105.71,60.27,106.91,60.27z')
            path(d='M106.91,45.87c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C104.75,44.9,105.71,45.87,106.91,45.87z')
            path(d='M106.91,31.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C104.75,30.5,105.71,31.47,106.91,31.47z')
            path(d='M106.91,12.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C109.07,13.71,108.1,12.75,106.91,12.75z')
        g
            path(d='M97.55,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C98.51,135.15,97.55,136.12,97.55,137.31z')
            path(d='M99.71,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C101.87,121.72,100.9,120.75,99.71,120.75z')
            path(d='M99.71,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C101.87,107.32,100.9,106.35,99.71,106.35z')
            path(d='M99.71,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C101.87,92.92,100.9,91.95,99.71,91.95z')
            path(d='M99.71,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C101.87,78.52,100.9,77.55,99.71,77.55z')
            path(d='M99.71,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C97.55,66.5,98.51,67.47,99.71,67.47z')
            path(d='M99.71,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C97.55,52.1,98.51,53.07,99.71,53.07z')
            path(d='M99.71,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C97.55,37.7,98.51,38.67,99.71,38.67z')
            path(d='M99.71,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C97.55,23.3,98.51,24.27,99.71,24.27z')
            path(d='M101.87,7.71c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C100.9,9.87,101.87,8.9,101.87,7.71z')
        g
            path(d='M111.95,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C112.91,135.15,111.95,136.12,111.95,137.31z')
            path(d='M114.11,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C116.27,121.72,115.3,120.75,114.11,120.75z')
            path(d='M114.11,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C116.27,107.32,115.3,106.35,114.11,106.35z')
            path(d='M114.11,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C116.27,92.92,115.3,91.95,114.11,91.95z')
            path(d='M114.11,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C116.27,78.52,115.3,77.55,114.11,77.55z')
            path(d='M114.11,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C111.95,66.5,112.91,67.47,114.11,67.47z')
            path(d='M114.11,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C111.95,52.1,112.91,53.07,114.11,53.07z')
            path(d='M114.11,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C111.95,37.7,112.91,38.67,114.11,38.67z')
            path(d='M114.11,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C111.95,23.3,112.91,24.27,114.11,24.27z')
            path(d='M114.01,9.86c-0.56-0.32-1.12-0.63-1.69-0.93C112.69,9.47,113.31,9.83,114.01,9.86z')
        g
            path(d='M94.67,144.51c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37C93.7,146.67,94.67,145.7,94.67,144.51z')
            path(d='M92.51,127.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C94.67,128.92,93.7,127.95,92.51,127.95z')
            path(d='M92.51,113.55c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C94.67,114.52,93.7,113.55,92.51,113.55z')
            path(d='M92.51,99.15c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C94.67,100.12,93.7,99.15,92.51,99.15z')
            path(d='M92.51,84.75c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79\
            c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16C94.67,85.71,93.7,84.75,92.51,84.75z')
            path(d='M90.35,72.51c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16\
            c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37C90.72,71.1,90.35,71.76,90.35,72.51z')
            path(d='M91.3,59.9c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C90.35,58.85,90.72,59.51,91.3,59.9z')
            path(d='M90.35,43.71c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16\
            c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37C90.72,42.3,90.35,42.96,90.35,43.71z')
            path(d='M91.3,31.1c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C90.35,30.05,90.72,30.71,91.3,31.1z')
            path(d='M90.35,14.91c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c1.19,0,2.16-0.97,2.16-2.16\
            c0-1.19-0.97-2.16-2.16-2.16c-0.45,0-0.86,0.14-1.21,0.37C90.72,13.5,90.35,14.16,90.35,14.91z')
            path(d='M91.3,2.3c0.34,0.23,0.76,0.37,1.21,0.37c0.59,0,1.12-0.24,1.51-0.62c-1.16-0.27-2.33-0.52-3.51-0.74\
            C90.67,1.71,90.94,2.06,91.3,2.3z')
        g
            path(d='M78.11,142.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,143.32,79.3,142.35,78.11,142.35z')
            path(d='M78.11,127.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,128.92,79.3,127.95,78.11,127.95z')
            path(d='M78.11,113.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,114.52,79.3,113.55,78.11,113.55z')
            path(d='M78.11,99.15c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,100.12,79.3,99.15,78.11,99.15z')
            path(d='M78.11,84.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,85.71,79.3,84.75,78.11,84.75z')
            path(d='M78.11,70.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,71.31,79.3,70.35,78.11,70.35z')
            path(d='M78.11,60.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C75.95,59.3,76.91,60.27,78.11,60.27z')
            path(d='M78.11,45.87c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C75.95,44.9,76.91,45.87,78.11,45.87z')
            path(d='M78.11,31.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C75.95,30.5,76.91,31.47,78.11,31.47z')
            path(d='M78.11,12.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C80.27,13.71,79.3,12.75,78.11,12.75z')
            path(d='M78.11,2.67c1.19,0,2.16-0.97,2.16-2.16c0-0.14-0.02-0.28-0.04-0.41C78.98,0.03,77.73,0,76.47,0\
            c-0.15,0-0.3,0.01-0.46,0.01c-0.04,0.16-0.06,0.32-0.06,0.49C75.95,1.7,76.91,2.67,78.11,2.67z')
        g
            path(d='M70.91,149.55c-1.19,0-2.16,0.97-2.16,2.16c0,0.33,0.08,0.64,0.21,0.92c1.24,0.12,2.49,0.22,3.74,0.28\
            c0.23-0.34,0.36-0.75,0.36-1.2C73.07,150.52,72.1,149.55,70.91,149.55z')
            path(d='M68.75,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C69.71,135.15,68.75,136.12,68.75,137.31z')
            path(d='M70.91,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C73.07,121.72,72.1,120.75,70.91,120.75z')
            path(d='M70.91,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C73.07,107.32,72.1,106.35,70.91,106.35z')
            path(d='M70.91,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C73.07,92.92,72.1,91.95,70.91,91.95z')
            path(d='M70.91,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C73.07,78.52,72.1,77.55,70.91,77.55z')
            path(d='M70.91,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C68.75,66.5,69.71,67.47,70.91,67.47z')
            path(d='M70.91,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C68.75,52.1,69.71,53.07,70.91,53.07z')
            path(d='M70.91,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C68.75,37.7,69.71,38.67,70.91,38.67z')
            path(d='M70.91,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C68.75,23.3,69.71,24.27,70.91,24.27z')
            path(d='M73.07,7.71c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C72.1,9.87,73.07,8.9,73.07,7.71z')
        g
            path(d='M85.31,149.55c-1.19,0-2.16,0.97-2.16,2.16c0,0.35,0.09,0.67,0.24,0.97c1.35-0.12,2.69-0.27,4.02-0.46\
            c0.04-0.16,0.06-0.33,0.06-0.5C87.47,150.52,86.5,149.55,85.31,149.55z')
            path(d='M83.15,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C84.11,135.15,83.15,136.12,83.15,137.31z')
            path(d='M85.31,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C87.47,121.72,86.5,120.75,85.31,120.75z')
            path(d='M85.31,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C87.47,107.32,86.5,106.35,85.31,106.35z')
            path(d='M85.31,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C87.47,92.92,86.5,91.95,85.31,91.95z')
            path(d='M85.31,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C87.47,78.52,86.5,77.55,85.31,77.55z')
            path(d='M85.31,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C83.15,66.5,84.11,67.47,85.31,67.47z')
            path(d='M85.31,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C83.15,52.1,84.11,53.07,85.31,53.07z')
            path(d='M85.31,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C83.15,37.7,84.11,38.67,85.31,38.67z')
            path(d='M85.31,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C83.15,23.3,84.11,24.27,85.31,24.27z')
            path(d='M87.47,7.71c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C86.5,9.87,87.47,8.9,87.47,7.71z')
        g
            path(d='M49.31,142.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,143.32,50.5,142.35,49.31,142.35z')
            path(d='M49.31,127.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,128.92,50.5,127.95,49.31,127.95z')
            path(d='M49.31,113.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,114.52,50.5,113.55,49.31,113.55z')
            path(d='M49.31,99.15c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,100.12,50.5,99.15,49.31,99.15z')
            path(d='M49.31,84.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,85.71,50.5,84.75,49.31,84.75z')
            path(d='M49.31,70.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,71.31,50.5,70.35,49.31,70.35z')
            path(d='M49.31,60.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C47.15,59.3,48.11,60.27,49.31,60.27z')
            path(d='M49.31,45.87c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C47.15,44.9,48.11,45.87,49.31,45.87z')
            path(d='M49.31,31.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C47.15,30.5,48.11,31.47,49.31,31.47z')
            path(d='M49.31,12.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C51.47,13.71,50.5,12.75,49.31,12.75z')
        g
            path(d='M65.5,143.3c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,143.65,65.5,143.3z')
            path(d='M65.5,128.9c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,129.25,65.5,128.9z')
            path(d='M65.5,114.5c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,114.85,65.5,114.5z')
            path(d='M65.5,100.1c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,100.45,65.5,100.1z')
            path(d='M65.5,85.7c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,86.04,65.5,85.7z')
            path(d='M65.5,71.3c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S65.73,71.64,65.5,71.3z')
            path(d='M62.5,59.9c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21\
            c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C61.55,58.85,61.92,59.51,62.5,59.9z')
            path(d='M61.55,43.71c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95\
            c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37\
            C61.92,42.3,61.55,42.96,61.55,43.71z')
            path(d='M62.5,31.1c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21\
            c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C61.55,30.05,61.92,30.71,62.5,31.1z')
            path(d='M61.55,14.91c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95\
            c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37\
            C61.92,13.5,61.55,14.16,61.55,14.91z')
            path(d='M61.76,1.43c0.17,0.35,0.42,0.65,0.74,0.87c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95\
            c0.19-0.28,0.3-0.61,0.34-0.96C64.47,0.94,63.11,1.16,61.76,1.43z')
        g
            path(d='M39.95,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C40.91,135.15,39.95,136.12,39.95,137.31z')
            path(d='M42.11,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C44.27,121.72,43.3,120.75,42.11,120.75z')
            path(d='M42.11,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C44.27,107.32,43.3,106.35,42.11,106.35z')
            path(d='M42.11,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C44.27,92.92,43.3,91.95,42.11,91.95z')
            path(d='M42.11,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C44.27,78.52,43.3,77.55,42.11,77.55z')
            path(d='M42.11,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C39.95,66.5,40.91,67.47,42.11,67.47z')
            path(d='M42.11,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C39.95,52.1,40.91,53.07,42.11,53.07z')
            path(d='M42.11,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C39.95,37.7,40.91,38.67,42.11,38.67z')
            path(d='M42.11,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C39.95,23.3,40.91,24.27,42.11,24.27z')
            path(d='M42.11,9.87c1.19,0,2.16-0.97,2.16-2.16c0-0.2-0.03-0.38-0.08-0.56c-1.28,0.6-2.54,1.22-3.78,1.88\
            C40.8,9.53,41.41,9.87,42.11,9.87z')
        g
            path(d='M56.51,149.55c-0.49,0-0.93,0.17-1.29,0.44c1.08,0.31,2.17,0.6,3.27,0.87C58.16,150.09,57.39,149.55,56.51,149.55z')
            path(d='M54.35,137.31c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C55.31,135.15,54.35,136.12,54.35,137.31z')
            path(d='M56.51,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C58.67,121.72,57.7,120.75,56.51,120.75z')
            path(d='M56.51,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C58.67,107.32,57.7,106.35,56.51,106.35z')
            path(d='M56.51,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C58.67,92.92,57.7,91.95,56.51,91.95z')
            path(d='M56.51,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C58.67,78.52,57.7,77.55,56.51,77.55z')
            path(d='M56.51,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C54.35,66.5,55.31,67.47,56.51,67.47z')
            path(d='M56.51,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C54.35,52.1,55.31,53.07,56.51,53.07z')
            path(d='M56.51,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C54.35,37.7,55.31,38.67,56.51,38.67z')
            path(d='M56.51,24.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C54.35,23.3,55.31,24.27,56.51,24.27z')
            path(d='M58.67,7.71c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C57.7,9.87,58.67,8.9,58.67,7.71z')
        path(d='M14.24,120.97c0.4,0.55,0.79,1.11,1.2,1.65C15.34,121.89,14.88,121.28,14.24,120.97z')
        g
            path(d='M20.51,127.95c-0.2,0-0.39,0.04-0.57,0.09c0.85,0.93,1.73,1.84,2.62,2.73c0.07-0.21,0.11-0.43,0.11-0.66\
            C22.67,128.92,21.7,127.95,20.51,127.95z')
            path(d='M20.51,113.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C22.67,114.52,21.7,113.55,20.51,113.55z')
            path(d='M20.51,99.15c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C22.67,100.12,21.7,99.15,20.51,99.15z')
            path(d='M20.51,84.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C22.67,85.71,21.7,84.75,20.51,84.75z')
            path(d='M20.51,74.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C18.35,73.7,19.31,74.67,20.51,74.67z')
            path(d='M20.51,60.27c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C18.35,59.3,19.31,60.27,20.51,60.27z')
            path(d='M20.51,41.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C22.67,42.51,21.7,41.55,20.51,41.55z')
            path(d='M20.51,31.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C18.35,30.5,19.31,31.47,20.51,31.47z')
        g
            path(d='M11.15,108.51c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C12.11,106.35,11.15,107.32,11.15,108.51z')
            path(d='M13.31,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C15.47,92.92,14.5,91.95,13.31,91.95z')
            path(d='M13.31,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C15.47,78.52,14.5,77.55,13.31,77.55z')
            path(d='M13.31,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C11.15,66.5,12.11,67.47,13.31,67.47z')
            path(d='M11.15,50.91c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16\
            C12.11,48.75,11.15,49.71,11.15,50.91z')
            path(d='M13.31,38.67c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-0.27,0-0.53,0.06-0.77,0.15\
            c-0.47,0.71-0.94,1.43-1.38,2.15C11.23,37.77,12.16,38.67,13.31,38.67z')
        g
            path(d='M27.71,135.15c-0.1,0-0.2,0.02-0.31,0.03c0.8,0.67,1.62,1.32,2.45,1.96C29.76,136.03,28.84,135.15,27.71,135.15z')
            path(d='M27.71,120.75c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C29.87,121.72,28.9,120.75,27.71,120.75z')
            path(d='M27.71,106.35c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C29.87,107.32,28.9,106.35,27.71,106.35z')
            path(d='M27.71,91.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C29.87,92.92,28.9,91.95,27.71,91.95z')
            path(d='M27.71,77.55c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C29.87,78.52,28.9,77.55,27.71,77.55z')
            path(d='M27.71,67.47c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C25.55,66.5,26.51,67.47,27.71,67.47z')
            path(d='M27.71,53.07c1.19,0,2.16-0.97,2.16-2.16c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16\
            C25.55,52.1,26.51,53.07,27.71,53.07z')
            path(d='M29.87,36.51c0-1.19-0.97-2.16-2.16-2.16c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16\
            C28.9,38.67,29.87,37.7,29.87,36.51z')
            path(d='M27.71,19.95c-1.19,0-2.16,0.97-2.16,2.16c0,1.19,0.97,2.16,2.16,2.16c1.19,0,2.16-0.97,2.16-2.16\
            C29.87,20.91,28.9,19.95,27.71,19.95z')
        g
            path(d='M36.7,128.9c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S36.93,129.25,36.7,128.9z')
            path(d='M36.7,114.5c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S36.93,114.85,36.7,114.5z')
            path(d='M36.7,100.1c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S36.93,100.45,36.7,100.1z')
            path(d='M36.7,85.7c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21\
            S36.93,86.04,36.7,85.7z')
            path(d='M32.75,72.51c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95\
            c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37\
            C33.12,71.1,32.75,71.76,32.75,72.51z')
            path(d='M33.7,59.9c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21\
            c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C32.75,58.85,33.12,59.51,33.7,59.9z')
            path(d='M33.7,45.5c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21\
            c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C32.75,44.45,33.12,45.11,33.7,45.5z')
            path(d='M33.7,31.1c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21\
            c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79C32.75,30.05,33.12,30.71,33.7,31.1z')
            path(d='M32.75,14.91c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.74,0,1.4-0.38,1.79-0.95\
            c0.23-0.34,0.37-0.76,0.37-1.21s-0.14-0.86-0.37-1.21c-0.39-0.57-1.05-0.95-1.79-0.95c-0.45,0-0.86,0.14-1.21,0.37\
            C33.12,13.5,32.75,14.16,32.75,14.91z')
        g
            path(d='M7.63,99.78c-0.39-0.39-0.93-0.63-1.53-0.63c-0.45,0-0.86,0.14-1.21,0.37c-0.48,0.32-0.82,0.84-0.92,1.44\
            c0.22,0.65,0.43,1.3,0.66,1.94c0.08,0.08,0.16,0.15,0.26,0.21c0.34,0.23,0.76,0.37,1.21,0.37c0.6,0,1.14-0.24,1.53-0.63\
            s0.63-0.93,0.63-1.53C8.26,100.71,8.02,100.17,7.63,99.78z')
            path(d='M7.63,85.38c-0.39-0.39-0.93-0.63-1.53-0.63c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.6,0,1.14-0.24,1.53-0.63s0.63-0.93,0.63-1.53\
            C8.26,86.31,8.02,85.77,7.63,85.38z')
            path(d='M7.63,70.98c-0.39-0.39-0.93-0.63-1.53-0.63c-0.45,0-0.86,0.14-1.21,0.37c-0.57,0.39-0.95,1.05-0.95,1.79\
            c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37c0.6,0,1.14-0.24,1.53-0.63s0.63-0.93,0.63-1.53\
            C8.26,71.91,8.02,71.37,7.63,70.98z')
            path(d='M6.38,45.84c0.49-0.06,0.93-0.28,1.26-0.61c0.39-0.39,0.63-0.93,0.63-1.53c0-0.43-0.13-0.83-0.35-1.17\
            C7.38,43.62,6.86,44.73,6.38,45.84z')
            path(d='M4.9,56.32c-0.57,0.39-0.95,1.05-0.95,1.79c0,0.75,0.38,1.4,0.95,1.79c0.34,0.23,0.76,0.37,1.21,0.37\
            c0.6,0,1.14-0.24,1.53-0.63s0.63-0.93,0.63-1.53c0-0.6-0.24-1.14-0.63-1.53s-0.93-0.63-1.53-0.63C5.66,55.95,5.24,56.08,4.9,56.32z\
            ')
        g
            path(d='M1.07,79.71c0-0.79-0.43-1.48-1.07-1.85c0.02,1.21,0.07,2.42,0.14,3.62C0.7,81.08,1.07,80.44,1.07,79.71z')
            path(d='M1.07,65.31c0-0.28-0.06-0.55-0.16-0.8C0.8,65.2,0.72,65.9,0.62,66.6C0.9,66.24,1.07,65.79,1.07,65.31z')

    h2 Loading...
</template>


<script>
export default {
    name: 'Loader',
    props: [""]
}
</script>


<style lang="scss" scoped>
.loader {
    width: fit-content;
    margin: auto;
    h1,
    svg {
        margin: auto
    }

    h2 {
        font-weight: bold;
        font-family: $fontFamilyHeadings;
        text-transform: uppercase;
    }

    svg {
        width: 200px;
        height: 200px;
        overflow: scroll
    }

    #Loader {
        transform: rotate(70Deg);

        path {
            fill: $brightBlue;

        }

        // g{transform-origin: center center;}
        $i: 1;
        $delay: .145;
        $duration: 3;
        $addedDelay: .045;

        @while $i < 200 {

            g path:nth-of-type(#{$i}) {
                animation: myAnim #{$duration}s ease #{$delay}s infinite forwards;
            }

            $i: $i + 1;
            $delay: $delay + $addedDelay
        }
    }
}

@keyframes myAnim {

    0%,
    50%,
    100% {
        transform: scale(1, 1);
        opacity: 1;
        fill: $brightBlue;
    }

    25%,
    75% {
        transform: scale(1.05, 1.05);
        fill: $coral;
    }
}
</style>
